import AppFetch from 'fetch/AppFetch';
// CONSTANTS
import { moduleConfig } from 'lib/config/appConstants';

export function EntitledProducts(userInfo) {
  // if userInfo not passed in return null
  if (!userInfo || !userInfo.products) {
    return null;
  }

  const entitledProducts = {};

  userInfo.products.forEach((product) => {
    if (product.hasOwnProperty('H-W') && userInfo.can_access_legacy_hw_ret === '1') {
      //Health and Welfare
      entitledProducts['HWR'] = true;
    }
    if (product.hasOwnProperty('SGR') && userInfo.can_access_legacy_hw_ret === '1') {
      // Retirement
      entitledProducts['RET'] = true;
    }
    if (product.hasOwnProperty('H-W')) {
      // Employee Benefits
      entitledProducts['EB'] = true;
    }
    if (product.hasOwnProperty('PC')) {
      // Commercial Lines
      entitledProducts['PAC'] = true;
    }
    if (product.hasOwnProperty('A-R')) {
      // Analytics
      entitledProducts['HAN'] = true;
    }
  });

  return entitledProducts;
}

/**
 * Used to verify the user is authorized for either PC and/or EB based on the page they are on
 * @param nextState
 * @param replace
 */
export const checkAuthorization = () => {
  // get current url
  const targetPath = window.location.href;

  // all pc paths in app
  const pcPaths = [
    moduleConfig.PC.home,
    moduleConfig.PC.results,
    '/edge/alternate-addresses/' + moduleConfig.PC.shortName,
    '/edge/myaccount/' + moduleConfig.PC.shortName,
  ];

  // all eb paths in the app
  const ebPaths = [
    moduleConfig.EB.home,
    moduleConfig.EB.results,
    '/edge/alternate-addresses/' + moduleConfig.EB.shortName,
    '/edge/myaccount/' + moduleConfig.EB.shortName,
  ];

  // get user info object
  const userInfo = AppFetch.fetchUserInfo();

  // find products the user is authorized for
  const productCodes = userInfo.products.map((product) => {
    return product.hasOwnProperty('PC') ? 'PC' : product.hasOwnProperty('H-W') ? 'H-W' : '?';
  });

  let isAuthorized = true;
  let homePathName = '/'; // A path where the Link "Home" will navigate to

  // Is accessing PC
  pcPaths.forEach((path) => {
    if (targetPath.indexOf(path) !== -1) {
      // Yes. PC's page
      isAuthorized = Array.isArray(userInfo.products) && productCodes.indexOf('PC') !== -1;
      // The Home path in case un-authorized
      homePathName = productCodes.indexOf('H-W') !== -1 ? moduleConfig.EB.home : homePathName;
    }
  });

  // Is accessing EB
  ebPaths.forEach((path) => {
    if (targetPath.indexOf(path) !== -1) {
      // Yes. EB's page
      isAuthorized = Array.isArray(userInfo.products) && productCodes.indexOf('H-W') !== -1;
      // The Home path in case un-authorized
      homePathName = productCodes.indexOf('PC') !== -1 ? moduleConfig.PC.home : homePathName;
    }
  });

  // return object with if the user is authorized, and if not, what page they should be redirected to
  return {
    isAuthorized,
    homePathUri: homePathName,
  };
};
